<template>
  <div class="p-limit">
    <div class="p-limit--inner">
      <p>並び替え機能をご利用いただくためには、会員登録が必要です。</p>
      <a class="p-limit--inner--button p-limit--inner--button__red" @click="navigateToRegister">会員登録</a>
      <a class="p-limit--inner--button p-limit--inner--button__red" @click="login">ログイン</a>
      <a class="p-limit--inner--button p-limit--inner--button__black" @click="goBack">会員登録せずに物件を探す</a>
      <button class="p-limit--inner--batsu" @click="goBack">
        <img :src="require('@/assets/images/batsu-limit.png')" />
      </button>
    </div>
  </div>
</template>

<script>
import { signIn, saveRegisterRedirect } from '@/utils/auth';

export default {
  name: 'CommonViewLimited',
  props: ['directLink', 'isViewLimited'],
  data() {
    return {};
  },
  methods: {
    navigateToRegister() {
      saveRegisterRedirect();
      this.$router.push('/member/signup');
    },
    goBack() {
      if (this.directLink) {
        // 直リンク
        location.href = location.href.replace(/order=[0-9]/, 'order=0');
      } else {
        this.isLimited = false;
      }
    },
    login() {
      signIn();
    },
  },
  computed: {
    isLimited: {
      get() {
        return this.isViewLimited;
      },
      set(isViewLimited) {
        this.$emit('input', isViewLimited);
      },
    },
  },
};
</script>

<style lang='scss' scoped>
@charset 'UTF-8';

.p-limit {
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  background-color: rgba($color: #FFF, $alpha: 0.7);
  display:flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  &--inner {
    width: 100%;
    max-width: 520px;
    position: relative;
    p {
      margin: 120px auto 45px;
      text-align: center;
      font-size: 16px;
      font-weight: bold;
    }
    &--button {
      width: 272px;
      height:59px;
      font-size: 18px;
      font-weight: bold;
      border-radius: 30px;
      display: flex;
      justify-content: center;
      align-items: center;
      margin: 0 auto 20px;
      background-color: #FFF;
      &__red {
        color: #E83532;
        border: 1px solid #E83532;
      }
      &__red:hover {
        color: #FFF;
        background-color: #E83532;
        border: 1px solid #E83532;
      }
      &__black {
        color: #666666;
        border: 1px solid #707070;
      }
      &__black:hover {
        color: #FFF;
        background-color: #707070;
        border: 1px solid #707070;
      }
    }
    &--batsu {
      opacity:0.6;
      position: absolute;
      top: 0;
      right: 40px;
    }
  }
}
</style>
